import { render, staticRenderFns } from "./TakipHazirlaFormBetaWizard.vue?vue&type=template&id=48d430b4&scoped=true"
import script from "./TakipHazirlaFormBetaWizard.vue?vue&type=script&lang=ts"
export * from "./TakipHazirlaFormBetaWizard.vue?vue&type=script&lang=ts"
import style0 from "./TakipHazirlaFormBetaWizard.vue?vue&type=style&index=0&id=48d430b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d430b4",
  null
  
)

export default component.exports